import type { JobStatus } from "../types";

export type ScraperColor = "blue" | "purple" | "amber" | "teal" | "green";
const COLORS: ScraperColor[] = ["blue", "purple", "amber", "teal", "green"];

// Deterministic scraper-name → color mapping so that the same scraper
// always gets the same dot/tag color across pages.
export function scraperColor(name: string | undefined | null): ScraperColor {
  if (!name) return "blue";
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return COLORS[h % COLORS.length]!;
}

export function ScraperDot({ name }: { name: string }) {
  return <span className={`crl-sdot c-${scraperColor(name)}`} />;
}

export function ScraperTag({ name, label }: { name: string; label?: string }) {
  return (
    <span className={`crl-stag c-${scraperColor(name)}`}>
      <span className="crl-tdot" />
      {label ?? name}
    </span>
  );
}

const STATUS_CLASS: Record<JobStatus, string> = {
  queued: "queued",
  running: "running",
  done: "done",
  failed: "failed",
};

const STATUS_LABEL: Record<JobStatus, string> = {
  queued: "Queued",
  running: "Running",
  done: "Completed",
  failed: "Failed",
};

export function StatusPill({ status }: { status: JobStatus }) {
  const pulse = status === "running";
  return (
    <span className={`crl-pill ${STATUS_CLASS[status]}`}>
      {pulse ? <span className="crl-pulse" /> : <span className="crl-pdot" />}
      {STATUS_LABEL[status]}
    </span>
  );
}
